const FILTER_KEYS = ['service', 'status', 'customer', 'seller', 'owner', 'area'];

export const createDefaultSalesToolbarFilters = () => ({
  search: '',
  date_start: '',
  date_end: '',
  service: [],
  status: [],
  customer: [],
  seller: [],
  owner: [],
  area: [],
});

export const normalizeSalesToolbarFilters = (filters) => {
  const normalized = filters && typeof filters === 'object' ? filters : {};

  const next = {
    ...createDefaultSalesToolbarFilters(),
    ...normalized,
  };

  FILTER_KEYS.forEach((key) => {
    next[key] = Array.isArray(next[key]) ? next[key] : [];
  });

  next.search = String(next.search || '').trim();
  next.date_start = String(next.date_start || '').trim();
  next.date_end = String(next.date_end || '').trim();

  return next;
};

export const buildSalesListParams = ({ toolbarFilters, toolbarSearch }) => {
  const filters = normalizeSalesToolbarFilters(toolbarFilters);

  return {
    search: String(filters.search || toolbarSearch || '').trim(),
    date_start: filters.date_start,
    date_end: filters.date_end,
    service: filters.service,
    status: filters.status,
    customer: filters.customer,
    seller: filters.seller,
    owner: filters.owner,
    area: filters.area,
  };
};

const normalizeStringValue = (value) => String(value || '').trim().toLowerCase();

const buildSelectedSet = (values) => {
  const normalized = Array.isArray(values) ? values : [];
  const filtered = normalized
    .map((value) => normalizeStringValue(value))
    .filter((value) => value !== '' && value !== 'all');

  return new Set(filtered);
};

const matchesCandidateSet = (selectedSet, candidates) => {
  if (!(selectedSet instanceof Set) || selectedSet.size === 0) {
    return true;
  }

  const safeCandidates = Array.isArray(candidates) ? candidates : [];
  return safeCandidates
    .map((candidate) => normalizeStringValue(candidate))
    .some((candidate) => candidate !== '' && selectedSet.has(candidate));
};

const buildSearchHaystack = (row) => {
  return [
    row?.sale_name,
    row?.project,
    row?.name,
    row?.code,
    row?.reference,
    row?.company_name,
    row?.customer_name,
    row?.cliente,
    row?.service_name,
    row?.service,
    row?.service_type,
  ]
    .map((value) => normalizeStringValue(value))
    .join(' ');
};

export const matchesSalesSearch = (row, searchTerm) => {
  const search = normalizeStringValue(searchTerm);
  if (!search) {
    return true;
  }

  return buildSearchHaystack(row).includes(search);
};

export const matchesSalesFilters = (row, filters) => {
  const normalizedFilters = normalizeSalesToolbarFilters(filters);

  const serviceSet = buildSelectedSet(normalizedFilters.service);
  const statusSet = buildSelectedSet(normalizedFilters.status);
  const customerSet = buildSelectedSet(normalizedFilters.customer);
  const sellerSet = buildSelectedSet(normalizedFilters.seller);
  const ownerSet = buildSelectedSet(normalizedFilters.owner);
  const areaSet = buildSelectedSet(normalizedFilters.area);

  if (!matchesCandidateSet(serviceSet, [row?.service_type_id, row?.service_id, row?.service, row?.service_name, row?.service_type])) {
    return false;
  }

  if (!matchesCandidateSet(statusSet, [row?.status_sale_id, row?.status_id, row?.status, row?.status_name, row?.status_key, row?.stage])) {
    return false;
  }

  if (!matchesCandidateSet(customerSet, [row?.company_id, row?.customer_id, row?.company_name, row?.customer_name, row?.cliente])) {
    return false;
  }

  if (!matchesCandidateSet(sellerSet, [row?.seller_id, row?.salesman_id, row?.seller, row?.seller_name])) {
    return false;
  }

  if (!matchesCandidateSet(ownerSet, [row?.owner_id, row?.manager_id, row?.responsible_id, row?.owner, row?.owner_name, row?.responsible])) {
    return false;
  }

  if (!matchesCandidateSet(areaSet, [row?.area_id, row?.area, row?.area_name])) {
    return false;
  }

  return true;
};

export const filterSalesRowsLocal = (rows, searchTerm, filters) => {
  const sourceRows = Array.isArray(rows) ? rows : [];

  return sourceRows.filter((row) => {
    if (!matchesSalesSearch(row, searchTerm)) {
      return false;
    }

    return matchesSalesFilters(row, filters);
  });
};
